module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/characters-pictogram-6fa6de79dd62d9e019fa091a5ff5885b.svg";